import { render } from "./DebarkFlightGroup.vue?vue&type=template&id=6fa40e32"
import script from "./DebarkFlightGroup.vue?vue&type=script&lang=js"
export * from "./DebarkFlightGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__